import { Card, CardActions, CardContent,makeStyles, Grid,Button,Typography,IconButton } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import Link from "@material-ui/core/Link";
//import { makeStyles } from "@material-ui/styles";
import { useMediaQuery } from "react-responsive";
import { useTranslation } from "react-i18next";
import Close from "@material-ui/icons/Close"
import { commonService } from "../../../services";
import Brac_bank from "../../../assests/Brac_bank.png";
import { Dialog, DialogContent, DialogActions, DialogTitle } from "@material-ui/core";
import { useSelector } from "react-redux";
import WarningRoundedIcon from '@material-ui/icons/WarningRounded';
import { Skeleton } from "@material-ui/lab";
import { history } from "../../../helpers";
import { routePaths } from "../../config/route-paths";
const useStyle = makeStyles((theme) => ({
  actions: {
    bottom: "1rem",
    left: "-1rem",
    position: "relative",
    display: "flex",
    justifyContent: "end",
  },
  desc: {
    margin: "0.5rem 0 0.5rem 0",
    textAlign: "center",
  },
  img: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    height:'10vh'
  },
  title: {
    textAlign: "center",
  },
  cardStyle: {
    width: "50%",
    margin: "0 0.5rem",
  },
  mobileCard: {
    width: "95%",
    margin: "0.2rem 0.5rem",
  },
  dialogContainerStyling: {
    "& .MuiDialog-paperWidthSm": {
      [theme.breakpoints.up("sm")]: {
        minWidth: "25rem !important"
      },
      [theme.breakpoints.down("sm")]: {
        minWidth: "20rem !important"
      },
    }
  },
  closeIcon: {
    color: theme.palette.eWhite.base,
  },
  rightIcon: {
    textAlign: "-webkit-right",
  },
  contentColor: {
    background: theme.palette.ePrimary.base,
    color: theme.palette.eWhite.base,
    paddingLeft: "5%",
  },
  contentColor: {
    background: theme.palette.ePrimary.base,
    color: theme.palette.eWhite.base,
    paddingLeft: "5%",
  },
  alertIcon: {
    color: theme?.palette?.eTertiary?.base,
    width: "4rem",
    height: "auto",
    display: "block",
    margin: "1rem auto",
  },
  yes: {
    backgroundColor: theme.palette.ePrimary.base,
    color: theme.palette.eWhite.base,
    borderRadius: 30,
    "&:hover": {
      backgroundColor: theme.palette.ePrimary.hover,
    },
    padding: "3% 35%",
  },
  no: {
    color: theme.palette.ePrimary.base,
  },
  dialoagActionPadding: {
    paddingTop: "0.938rem",
    paddingBottom: "0.938rem",
  },
  dialogTextPadding: {
    padding: "0rem 1.875rem 1.875rem",
    textAlign: "center"
  },
  cardCont: {
    minHeight: "inherit"
  },
  mainContentHeight: {
    minHeight: "65vh"
  },
  yesBtn:{
    color:'white',
    cursor:'pointer'
  },
  cardHeight:{
    height:'100%'
  },
  emptyImgAlign:{
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'end'
  }
  
}));

const EPrepaidOptions = ({ eachRecord }) => {
  const [img, setImage] = useState([]);
  const[dOpen,setDopen]=useState(false)
  const { t: labels, ready: labelreadyok } = useTranslation("label-E_ONE_TIME_PAYMENTS");
  const {t:content, ready: contentReady} = useTranslation("content-E_SUMMARY_REVIEW");
  const classes = useStyle();
 // const summaryReviewLabel = useSelector((state) => state?.labels?.data?.getLabels?.E_SUMMARY_REVIEW);
  const { t: summaryReviewLabel, ready: labelreadySummeryok }= useTranslation("label-E_SUMMARY_REVIEW");
  useEffect(() => {
    if(eachRecord){
      if(eachRecord?.Image=="Brac_bank"){
        setImage(Brac_bank)
      }else{
        commonService.getAssestUrl(eachRecord?.Image).then((res) => {
          setImage(res?.assetPath);
        });
      }
    }
  }, [eachRecord]);

  const handleClose = () => {
    setDopen(false);
  };

  const handlePayBtn=(url)=>{
    setDopen(true)
  }

  const handleRedirection=()=>{
    window.open(eachRecord?.Url,'_blank');
    history.push(routePaths.QUICK_PAY)
    setDopen(false);
  }


  const isMobile = useMediaQuery({ query: "(max-width:480px)" });
  return (
    <div className={isMobile ? classes.mobileCard : classes.cardStyle}>
      <Card className={!img?.includes("undefined")?classes.cardHeight:classes.emptyImgAlign}>
        <CardContent>
          <div className={classes.img}>
          { !img?.includes("undefined") &&  <img src={img} alt={img?.fallBackLabelKey} />}
          </div>
          <Typography className={classes.title} variant="body1">
            {eachRecord?.PaymentGatewayName}
          </Typography>
          <Typography className={classes.desc} variant="body2">
            {eachRecord?.Description}
          </Typography>
        </CardContent>
        <CardActions className={classes.actions}>
          <Button onClick={handlePayBtn}>
            {labelreadyok?labels("E_OTP_PAY_NOW"):""}
          </Button>
        </CardActions>
      </Card>
      <Dialog onClose={handleClose} open={dOpen} className={classes.dialogContainerStyling} >
      <Grid
          container
          alignItems="center"
          className={classes.contentColor}
          justify="space-between"
        >
          <Grid item xs={10}>
            <Typography variant="subtitle2">{labels("E_POPUP_HEADER")}</Typography>
          </Grid>
          <Grid item xs={2} className={classes.rightIcon}>
            <IconButton aria-label="close" onClick={handleClose}>
              <Close className={classes.closeIcon} />
            </IconButton>
          </Grid>
        </Grid>
        <DialogContent dividers>
          <WarningRoundedIcon className={classes.alertIcon} />
          {
            contentReady ? <Typography className={[classes.detailsSubLine, classes.dialogTextPadding]}
              dangerouslySetInnerHTML={{
                __html: labels("E_POPUP_AUTH_DESC"),
              }}
            >
            </Typography> : <Skeleton variant="text"></Skeleton>
          }

        </DialogContent>
        <DialogActions className={classes.dialoagActionPadding}>
          <Grid item xs={1} sm={1}>
            <Link component="button" onClick={() => { handleClose() }} underline="hover" className={classes.no}><Typography variant="button" >{summaryReviewLabel("E_NO_LABEL")}</Typography></Link>
          </Grid>
          <Grid item xs={3}>
            <Link
              className={classes.yes}
              size="small"
              align="right"
              to={eachRecord?.Url}
              onClick={handleRedirection}
            >
              <Typography variant="button" className={classes.yesBtn}>{summaryReviewLabel("E_YES_LABEL")}</Typography>
            </Link>
          </Grid>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default EPrepaidOptions;
